module.exports = __webpack_public_path__ + "static/media/reader_noshared.53ba6333.ico";